import { render, staticRenderFns } from "./CareLabelConfirmDialogue.vue?vue&type=template&id=3bf9e566&scoped=true&"
import script from "./CareLabelConfirmDialogue.vue?vue&type=script&lang=ts&"
export * from "./CareLabelConfirmDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./CareLabelConfirmDialogue.vue?vue&type=style&index=0&id=3bf9e566&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf9e566",
  null
  
)

export default component.exports